var Chart = require('chart.js');


var insertChart = function(canvasElement,chapter,displayLegend) {

    var ctx = canvasElement.getContext('2d');

    var myChart = new Chart(ctx, {
        type: 'horizontalBar',
        data: {
            labels: ["Correct", "Incorrect", "Skipped", "Unseen"],
            datasets: [{
                label: 'Score',
                data: [ chapter.correct, chapter.incorrect, chapter.skipped, chapter.unseen],
                backgroundColor: [
                    'rgba(0, 168, 0, 0.7)',
                    'rgba(128, 28, 45, 0.7)',
                    'rgba(200, 200, 0, 0.7)',
                    'rgba(150, 150, 150, 0.7)'
                ],
            }]
        },
        options: { legend: { display : displayLegend }, responsive:true}
    });
}

module.exports = insertChart;


//////////////////
// WEBPACK FOOTER
// ./src/insertChart.js
// module id = 236
// module chunks = 0